var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"area"},[_c('h1',[_vm._v("Cambio de contraseña")]),_vm._v(" "),_c('h5',[_vm._v("El cambio de contraseña tambien afecta a su cuenta de MAJAT")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('nuevaContrasena',{attrs:{"requiereIngresarLaContrasenaActual":_vm.requiereIngresarLaContrasenaActual}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-75a1ed45","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Tablero/Usuario/CambioDeContrasena.vue
// module id = null
// module chunks = 